<div class="input-dialog">
  <div class="dialog-header">
    <mat-icon class="header-icon">{{ data.icon }}</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content>
    <div class="dialog-content">
      @if (data.message) {
        <p class="dialog-message">{{ data.message }}</p>
      }

      <form [formGroup]="inputForm" class="input-form">
        <mat-form-field
          appearance="outline"
          class="full-width"
          [class.field-error]="hasFieldError()"
          [class.field-success]="inputControl?.valid && inputControl?.touched">

          <mat-label>{{ data.inputLabel }}</mat-label>
          <input
            matInput
            [type]="data.inputType || 'text'"
            [placeholder]="data.inputPlaceholder || ''"
            formControlName="inputValue"
            (keyup.enter)="onConfirm()">

          @if (hasFieldError()) {
            <mat-error>
              {{ getFieldError() }}
            </mat-error>
          }

          @if (hasFieldError()) {
            <mat-icon matSuffix class="error-icon">error</mat-icon>
          }

          @if (inputControl?.valid && inputControl?.touched) {
            <mat-icon matSuffix class="success-icon">check_circle</mat-icon>
          }
        </mat-form-field>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button
      type="button"
      (click)="onCancel()"
      class="cancel-btn">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button
      type="button"
      color="primary"
      (click)="onConfirm()"
      [disabled]="inputForm.invalid"
      class="confirm-btn">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
